import { commonMessages, reportSpecificMessages } from '../../../../utility/commonMessages';

const areFilterDifferent = (before, after) => {
    // Easy preliminary check
    if (before.length !== after.length) {
        return true;
    }

    for (let i = 0; i < after.length; i += 1) {
        if (
            before[i].measure !== after[i].measure ||
            before[i].operator !== after[i].operator ||
            before[i].value !== after[i].value
        ) {
            return true;
        }
    }
    return false;
};

// TODO this is used in a few different places we can do a better job with this (Inputs.jsx and getOperator.js)
export const findComparisonOperator = (operator) => {
    if (operator === 'equals') {
        return '=';
    } else if (operator === 'lte') {
        return '<=';
    }
    return '>=';
};

export const getCustomFilterMessage = (reportCategory, reportName, columnId) => {
    const generalFilter = commonMessages.resultFilterValues[columnId];
    const reportSpecificFilter = reportSpecificMessages.resultFilterValues?.[reportCategory]?.[reportName]?.[columnId];
    return reportSpecificFilter || generalFilter;
};

export default {
    areFilterDifferent,
};
